<template>
  <div v-show="showDialog" class="mask">
    <div class="dialog">
        <div class="haeder">
            <div class="title">營運公告</div>
            <div class="closeBtn" @click="showDialog = false">X</div>
        </div>
        <div class="content">
            為提供會員更優質的服務，自2024/02/01起，原屬極巨光數位媒體行銷有限公司之SMchat營運服務將移轉至品睿數位媒體行銷有限公司接續服務。您原有的會員權益及服務在轉換過程中皆不受任何影響。
        </div>
        <div class="footer">
            品睿數位媒體行銷有限公司
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonDialog',
  data: () => ({
    showDialog: true
  })
}
</script>

<style>
.mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
}
.dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 300px;
    background-color: white;
    border: 1px solid #808080;
    border-radius: 20px;
    padding: 25px;
}
.haeder {
    position: relative;
    height: 60px;
    width: 100%;
}
.title {
    width: 100%;
    height: 60px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-weight: bold;
    color: black;
}
.closeBtn {
    width: 30px;
    height: 30px;
    position: absolute;
    top: -10px;
    right: -10px;
    font-size: 24px;
    cursor: pointer;
    text-align: center;
}
.content {
    width: 100%;
    color: #505050;
    font-size: 18px;
    text-align: justify;
}
.footer {
    position: absolute;
    bottom: 0;
    right: 20px;
    width: 90%;
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    font-size: 18px;
    color: #505050;
}
</style>
